export default __webpack_public_path__ + "static/media/bloodbath2.a15ab24e.png";